import { createSelector } from '@reduxjs/toolkit'

import { getProduct } from '../root.selectors'

export const getProductList = createSelector(getProduct, (state) => state.list)
export const getProductDetails = createSelector(getProduct, (state) => state.details)
export const getProductDetailsById = createSelector(
  [getProductDetails, (_state, id) => id],
  (slice, id) => slice.byId[id],
)
